import { useCallback, useEffect, useState } from "react";
import moment from "moment";
import { getBlockedDates } from "../apis/invitations.api";

export function useBlockedDates() {
  const [blockedDates, setBlockedDates] = useState<string[]>([]);

  const onMonthChange = useCallback((monthDate: Date) => {
    const month = moment(monthDate);
    const from = month.clone().startOf("month").format("YYYY-MM-DD");
    const to = month.clone().endOf("month").format("YYYY-MM-DD");

    getBlockedDates({ from, to }).then((response: any) => {
      if (response?.success && Array.isArray(response?.data)) {
        setBlockedDates(response.data);
      }
    });
  }, []);

  useEffect(() => {
    onMonthChange(new Date());
  }, [onMonthChange]);

  return { blockedDates, onMonthChange };
}
